import { parseLanguages } from "../utils/locale";
import locales from "./locales";

const getEnvVar = (key: string): string | undefined => {
  // 1. Priority: Runtime-Injection via Docker (window._env_)
  if (typeof window !== "undefined" && window._env_?.[key]) {
    return window._env_[key];
  }
  // 2. Fallback: Vite Environment Variables (Development only)
  return import.meta.env[key];
};

// bool values are provided via "yes" and "no" (like in core)
const getBoolEnvVar = (key: string): boolean => {
  return getEnvVar(key)?.toLowerCase() === "yes";
};

const config = {
  api: {
    baseURL: getEnvVar("REACT_APP_API_BASE_URL"),
  },
  build: {
    version: getEnvVar("BUILD_VERSION"),
    commit: getEnvVar("BUILD_COMMIT"),
  },
  appBaseUrl: window.location.host,
  maintenanceMode: getBoolEnvVar("REACT_APP_MAINTENANCE_MODE"),
  maintenanceModeDescription: getEnvVar("REACT_APP_MAINTENANCE_MODE_DESCRIPTION"),
  bcEditMasterDataUrl: getEnvVar("REACT_APP_BC_EDIT_MASTERDATA_URL") || undefined,
  bcForgotPasswordUrl: getEnvVar("REACT_APP_BC_FORGOT_PASSWORD_URL") || undefined,
  bcCfmBatteryPickupUrl: getEnvVar("REACT_APP_BC_CFM_BATTERY_PICKUP_URL") || undefined,
  environment: getEnvVar("REACT_APP_ENVIRONMENT"),
  applicationInsightsConnectionString: getEnvVar("REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING"),
  auth: {
    expirationKey: "wbt:expiresAt",
    tokenKey: "wbt:token",
    rolesKey: "wbt:user_roles",
    persistKey: "persist:auth",
    loginRedirect: "/",
    // No expiration constant here on purpose: session expiry is derived from the
    // token's own `exp` claim in utils/auth.ts, so it always matches the backend.
  },
  initial_state: {
    themeSource: "default",
    locale: "en",
  },
  featureToggles: {
    articleConfigurator: getBoolEnvVar("REACT_APP_FEATURE_ENABLE_CONFIGURATOR"),
  },
  locale: {
    defaultLocale: parseLanguages(["de"], "de") || "de",
    locales,
    persistKey: "locale",
    onError: (e: unknown) => {
      // Autodetect untranslated Text
      // For Performance reasons disable this most of the time
      // enable it only when you wan't to check for untranslated text

      const enabled = false;

      if (enabled) {
        const localeError = e as { descriptor: { id: string; defaultMessage?: string } };
        const { id, defaultMessage } = localeError.descriptor;
        const missingTranslations = JSON.parse(localStorage.getItem("missing_translations") ?? "");
        localStorage.setItem(
          "missing_translations",
          JSON.stringify({
            ...missingTranslations,
            [id]: defaultMessage ? defaultMessage : id,
          }),
        );
      }
      //console.log("e", e.descriptor);
      //Uncomment this to show react-intl missing translation warnings
      //console.warn(e)
      return;
    },
  },
};

export default config;
